
export default function CTASection() {
  return (
    <section className="py-10 sm:py-16 lg:py-20 bg-gradient-to-br from-green-600 to-green-800 relative overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/8d3382ca5caebbe6c3df3316b2a7f1e5.jpg"
          alt="Agua limpia"
          className="w-full h-full object-cover object-top opacity-20"
        />
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
        <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-white mb-3 sm:mb-6">
          ¿Necesitas agua segura?
        </h2>
        <p className="text-sm sm:text-lg md:text-xl text-white/95 mb-6 sm:mb-10 max-w-3xl mx-auto leading-relaxed">
          Contáctanos hoy y obtén una cotización personalizada. Nuestro equipo está listo para ayudarte.
        </p>

        <div className="flex flex-col gap-2 sm:gap-4 justify-center items-center mb-4 sm:mb-8">
          <a 
            href="https://wa.me/51994719367?text=Hola,%20necesito%20una%20cotización%20para%20perforación%20de%20pozo"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white hover:bg-gray-100 text-green-600 px-5 py-2.5 sm:px-8 sm:py-4 rounded-lg font-bold text-sm sm:text-lg transition-all shadow-2xl whitespace-nowrap cursor-pointer inline-flex items-center gap-2 w-full sm:w-auto justify-center max-w-xs sm:max-w-none"
          >
            <i className="ri-whatsapp-line text-lg sm:text-2xl"></i>
            +51 994 719 367
          </a>
          <a 
            href="https://wa.me/51953183017?text=Hola,%20necesito%20una%20cotización%20para%20perforación%20de%20pozo"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white hover:bg-gray-100 text-green-600 px-5 py-2.5 sm:px-8 sm:py-4 rounded-lg font-bold text-sm sm:text-lg transition-all shadow-2xl whitespace-nowrap cursor-pointer inline-flex items-center gap-2 w-full sm:w-auto justify-center max-w-xs sm:max-w-none"
          >
            <i className="ri-whatsapp-line text-lg sm:text-2xl"></i>
            +51 953 183 017
          </a>
        </div>

        <div className="flex flex-col gap-2 sm:gap-4 justify-center items-center mb-4 sm:mb-8">
          <a 
            href="tel:+51994719367"
            className="bg-green-500 hover:bg-green-400 text-white px-5 py-2.5 sm:px-8 sm:py-4 rounded-lg font-bold text-sm sm:text-lg transition-all shadow-2xl whitespace-nowrap cursor-pointer inline-flex items-center gap-2 w-full sm:w-auto justify-center max-w-xs sm:max-w-none"
          >
            <i className="ri-phone-line text-lg sm:text-2xl"></i>
            Llamar: +51 994 719 367
          </a>
          <a 
            href="tel:+51953183017"
            className="bg-green-500 hover:bg-green-400 text-white px-5 py-2.5 sm:px-8 sm:py-4 rounded-lg font-bold text-sm sm:text-lg transition-all shadow-2xl whitespace-nowrap cursor-pointer inline-flex items-center gap-2 w-full sm:w-auto justify-center max-w-xs sm:max-w-none"
          >
            <i className="ri-phone-line text-lg sm:text-2xl"></i>
            Llamar: +51 953 183 017
          </a>
        </div>

        <div className="mb-6 sm:mb-10">
          <a 
            href="mailto:perforacionesacuiferasdelorien@gmail.com"
            className="inline-flex items-center gap-2 text-white/95 hover:text-white text-xs sm:text-base font-semibold transition-all cursor-pointer"
          >
            <i className="ri-mail-line text-lg sm:text-xl flex-shrink-0"></i>
            <span className="break-all">perforacionesacuiferasdelorien@gmail.com</span>
          </a>
        </div>

        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 sm:p-8 border border-white/20 max-w-2xl mx-auto">
          <h3 className="text-lg sm:text-2xl font-bold text-white mb-2 sm:mb-4">
            👉 Cotización gratuita
          </h3>
          <p className="text-white/90 text-xs sm:text-base mb-4 sm:mb-6">
            Respuesta en menos de 24 horas • Sin compromiso
          </p>
          <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-2 sm:gap-4 text-white/90 text-xs sm:text-base">
            <div className="flex items-center justify-center gap-1.5">
              <i className="ri-checkbox-circle-fill text-base sm:text-xl"></i>
              <span>Evaluación gratuita</span>
            </div>
            <div className="flex items-center justify-center gap-1.5">
              <i className="ri-checkbox-circle-fill text-base sm:text-xl"></i>
              <span>Presupuesto detallado</span>
            </div>
            <div className="flex items-center justify-center gap-1.5">
              <i className="ri-checkbox-circle-fill text-base sm:text-xl"></i>
              <span>Atención inmediata</span>
            </div>
          </div>
        </div>

        <div className="mt-8 sm:mt-12 pt-6 sm:pt-8 border-t border-white/20">
          <p className="text-white/70 text-xs sm:text-sm">
            © 2024 Perforaciones Acuíferas del Oriente. Todos los derechos reservados.
          </p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-white/50 hover:text-white/70 text-xs mt-2 inline-block cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </section>
  );
}
